import { TipoItemQuestionario } from 'src/app/questionario/questao/model/tipo-item-questionario.enum';
import { ItemQuestionario } from '../../../questao/item-questionario-base';

export class QuestaoDescritiva extends ItemQuestionario<TipoItemQuestionario> {

  constructor(options: {} = {}) {
    super(options);
    this.questao.tipo = TipoItemQuestionario.DESCRITIVA;
  }

  getLabel(): string {
    return 'Texto';
  }

  getMaterialIcon(): string {
    return 'subject';
  }

  isQuestaoEstruturada(): boolean {
    return false;
  }
}
